import {
    FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS,
    FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING,
    FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
    FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS,
    FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING,
    FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
    FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS,
    FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING,
    FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
    FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS,
    FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_FETCHING,
    FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_FAIL,
    SWITCH_ENDURANCE_ACTIVE_TOGGLE
} from '../../actions/enduranceScoreActions';

const INITIAL_STATE = {
    dailyEnduranceScoreData: [],
    dailyEnduranceScoreDataFetching: false,
    dailyEnduranceScoreDataFetchFail: false,
    weeklyEnduranceScoreData: [],
    weeklyEnduranceScoreDataFetching: false,
    weeklyEnduranceScoreDataFetchFail: false,
    monthlyEnduranceScoreData: [],
    monthlyEnduranceScoreDataFetching: false,
    monthlyEnduranceScoreDataFetchFail: false,
    latestEnduranceScoreData: {},
    latestEnduranceScoreDataFetching: false,
    latestEnduranceScoreDataFetchFail: false,
    activeToggle: 'score'
};

// ======= Daily Fetching Handlers =======
const fetchDailyEnduranceScoreDataFetching = (state) => {
    return {
        ...state,
        dailyEnduranceScoreDataFetching: true,
        dailyEnduranceScoreDataFetchFail: false
    };
};

const fetchDailyEnduranceScoreDataSuccess = (state, action) => {
    return {
        ...state,
        dailyEnduranceScoreData: action.enduranceScoreData,
        dailyEnduranceScoreDataFetching: false,
        dailyEnduranceScoreDataFetchFail: false
    };
};

const fetchDailyEnduranceScoreDataFail = (state) => {
    return {
        ...state,
        dailyEnduranceScoreDataFetching: false,
        dailyEnduranceScoreDataFetchFail: true
    };
};

// ======= Weekly Fetching Handlers =======
const fetchWeeklyEnduranceScoreDataFetching = (state) => {
    return {
        ...state,
        weeklyEnduranceScoreDataFetching: true,
        weeklyEnduranceScoreDataFetchFail: false
    };
};

const fetchWeeklyEnduranceScoreDataSuccess = (state, action) => {
    return {
        ...state,
        weeklyEnduranceScoreData: action.enduranceScoreData,
        weeklyEnduranceScoreDataFetching: false,
        weeklyEnduranceScoreDataFetchFail: false
    };
};

const fetchWeeklyEnduranceScoreDataFail = (state) => {
    return {
        ...state,
        weeklyEnduranceScoreDataFetching: false,
        weeklyEnduranceScoreDataFetchFail: true
    };
};

// ======= Monthly Fetching Handlers =======
const fetchMonthlyEnduranceScoreDataFetching = (state) => {
    return {
        ...state,
        monthlyEnduranceScoreDataFetching: true,
        monthlyEnduranceScoreDataFetchFail: false
    };
};

const fetchMonthlyEnduranceScoreDataSuccess = (state, action) => {
    return {
        ...state,
        monthlyEnduranceScoreData: action.enduranceScoreData,
        monthlyEnduranceScoreDataFetching: false,
        monthlyEnduranceScoreDataFetchFail: false
    };
};

const fetchMonthlyEnduranceScoreDataFail = (state) => {
    return {
        ...state,
        monthlyEnduranceScoreDataFetching: false,
        monthlyEnduranceScoreDataFetchFail: true
    };
};

// ======= Latest Fetching Handlers =======

const fetchLatestEnduranceScoreDataFetching = (state) => {
    return {
        ...state,
        latestEnduranceScoreDataFetching: true,
        latestEnduranceScoreDataFetchFail: false
    };
};

const fetchLatestEnduranceScoreDataSuccess = (state, action) => {
    return {
        ...state,
        latestEnduranceScoreData: action.enduranceScoreData,
        latestEnduranceScoreDataFetching: false,
        latestEnduranceScoreDataFetchFail: false
    };
};

const fetchLatestEnduranceScoreDataFail = (state) => {
    return {
        ...state,
        latestEnduranceScoreDataFetching: false,
        latestEnduranceScoreDataFetchFail: true
    };
};

const switchToggle = (state, action) => ({
    ...state,
    activeToggle: action.payload
});

const resetToInitialState = () => INITIAL_STATE;

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING]: fetchDailyEnduranceScoreDataFetching,
    [FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS]: fetchDailyEnduranceScoreDataSuccess,
    [FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS_FAIL]: fetchDailyEnduranceScoreDataFail,
    [FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING]: fetchWeeklyEnduranceScoreDataFetching,
    [FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS]: fetchWeeklyEnduranceScoreDataSuccess,
    [FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS_FAIL]: fetchWeeklyEnduranceScoreDataFail,
    [FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_FETCHING]: fetchMonthlyEnduranceScoreDataFetching,
    [FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS]: fetchMonthlyEnduranceScoreDataSuccess,
    [FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS_FAIL]: fetchMonthlyEnduranceScoreDataFail,
    [FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_FETCHING]: fetchLatestEnduranceScoreDataFetching,
    [FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_SUCCESS]: fetchLatestEnduranceScoreDataSuccess,
    [FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS_FAIL]: fetchLatestEnduranceScoreDataFail,
    [SWITCH_ENDURANCE_ACTIVE_TOGGLE]: switchToggle
    // [RESET_PROFILE_PAGE]: resetToInitialState
};

// ======= Default Action ======
export default function enduranceScoreDataReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDailyEnduranceScoreData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_DAILY_ENDURANCE_SCORE_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchWeeklyEnduranceScoreData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_WEEKLY_ENDURANCE_SCORE_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchMonthlyEnduranceScoreData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_MONTHLY_ENDURANCE_SCORE_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchLatestEnduranceScoreData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_LATEST_ENDURANCE_SCORE_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function switchEnduranceActiveToggle(payload) {
    return {
        payload,
        type: SWITCH_ENDURANCE_ACTIVE_TOGGLE
    };
}

// ======= Selectors =======
export const getDailyEnduranceScoreData = (state) => {
    return state.enduranceScoreDataReports.dailyEnduranceScoreData
        ? state.enduranceScoreDataReports.dailyEnduranceScoreData
        : null;
};

export const isDailyEnduranceScoreDataFetching = (state) => {
    return state.enduranceScoreDataReports.dailyEnduranceScoreDataFetching;
};

export const didDailyEnduranceScoreDataFetchFail = (state) => {
    return state.enduranceScoreDataReports.dailyEnduranceScoreDataFetchFail;
};

export const getWeeklyEnduranceScoreData = (state) => {
    return state.enduranceScoreDataReports.weeklyEnduranceScoreData
        ? state.enduranceScoreDataReports.weeklyEnduranceScoreData
        : null;
};

export const isWeeklyEnduranceScoreDataFetching = (state) => {
    return state.enduranceScoreDataReports.weeklyEnduranceScoreDataFetching;
};

export const didWeeklyEnduranceScoreDataFetchFail = (state) => {
    return state.enduranceScoreDataReports.weeklyEnduranceScoreDataFetchFail;
};

export const getMonthlyEnduranceScoreData = (state) => {
    return state.enduranceScoreDataReports.monthlyEnduranceScoreData
        ? state.enduranceScoreDataReports.monthlyEnduranceScoreData
        : null;
};

export const isMonthlyEnduranceScoreDataFetching = (state) => {
    return state.enduranceScoreDataReports.monthlyEnduranceScoreDataFetching;
};

export const didMonthlyEnduranceScoreDataFetchFail = (state) => {
    return state.enduranceScoreDataReports.monthlyEnduranceScoreDataFetchFail;
};

export const getLatestEnduranceScoreData = (state) => {
    return state.enduranceScoreDataReports.latestEnduranceScoreData
        ? state.enduranceScoreDataReports.latestEnduranceScoreData
        : null;
};

export const isLatestEnduranceScoreDataFetching = (state) => {
    return state.enduranceScoreDataReports.latestEnduranceScoreDataFetching;
};

export const didLatestEnduranceScoreDataFetchFail = (state) => {
    return state.enduranceScoreDataReports.latestEnduranceScoreDataFetchFail;
};
